import { Heading, type HeadingProps } from "@chakra-ui/react";
import type { ReactNode } from "react";

function PageTitle({
	children,
	...props
}: { children: ReactNode } & HeadingProps) {
	return (
		<Heading
			as="h2"
			fontWeight={600}
			fontSize="32px"
			lineHeight="48px"
			fontFamily="Jakarta"
			pt={props.pt}
			pb={props.pb}
			display={props.display}
		>
			{children}
		</Heading>
	);
}

export default PageTitle;
